import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CustomButton from './CustomButton';
import { Button } from '@mui/material';
import './Header.css';

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const NAV_LINKS = [
  { to: '/', label: 'Início' },
  { to: '/parceiros', label: 'Parceiros' },
  { to: '/clientes', label: 'Clientes' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  return (
    <header className="top-0 z-50 w-full border-b bg-white/70 shadow-sm py-3">
      <div className="flex items-center justify-between container mx-auto px-6 max-w-[1200px]">
        <div className="flex items-center">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/logos/logo-azul.png"
              alt="Clube do Banho"
              className="h-11 w-auto"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          {NAV_LINKS.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="text-[15px] font-medium text-black/80 no-underline transition-colors hover:text-[#46558D] hover:font-semibold"
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-2">
          <Button variant='outlined' sx={{
            fontSize: '14px',
            color: '#000',
            backgroundColor: 'rgb(202,202,202,0.3)',
            borderRadius: '50px',
            padding: '10px 24px',
            textTransform: 'none',
            ':hover': { backgroundColor: 'rgb(202,202,202,0.6)' }
          }}>
            <a href='https://clube-do-banho-panel-staging-bfsrbcz6sq-uc.a.run.app/login' target="_blank" rel="noreferrer">
              Login do Parceiro
            </a>
          </Button>

          <CustomButton variant="contained" sx={{ fontSize: '14px' }}>
            <Link to="/cadastro-parceiro">Seja Parceiro</Link>
          </CustomButton>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          className="mobile-hamburger-btn"
          onClick={() => setIsMenuOpen(true)}
          aria-label="Abrir menu"
        >
          <MenuIcon />
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`mobile-drawer-overlay${isMenuOpen ? ' open' : ''}`}
        onClick={closeMenu}
        aria-hidden="true"
      />

      {/* Drawer */}
      <nav className={`mobile-drawer${isMenuOpen ? ' open' : ''}`} aria-label="Menu mobile">
        <div className="mobile-drawer-header">
          <img src="/logos/logo-azul.png" alt="Clube do Banho" className="h-9 w-auto" />
          <button className="mobile-drawer-close" onClick={closeMenu} aria-label="Fechar menu">
            <CloseIcon />
          </button>
        </div>

        <div className="mobile-drawer-nav">
          {NAV_LINKS.map(({ to, label }) => (
            <Link key={to} to={to} className="mobile-drawer-link" onClick={closeMenu}>
              {label}
            </Link>
          ))}
        </div>

        <div className="mobile-drawer-actions">
          <a
            href='https://clube-do-banho-panel-staging-bfsrbcz6sq-uc.a.run.app/login'
            target="_blank"
            rel="noreferrer"
            className="mobile-drawer-login-btn"
            onClick={closeMenu}
          >
            Login do Parceiro
          </a>
          <CustomButton variant="contained" sx={{ width: '100%', fontSize: '14px', borderRadius: '8px' }}>
            <Link to="/cadastro-parceiro" onClick={closeMenu}>Seja Parceiro</Link>
          </CustomButton>
        </div>
      </nav>
    </header>
  );
};

export default Header;
